import React, { Component } from "react";
import "./About.css";
class AboutUs extends Component {
  state = {
    skills: [
      "Android",
      "Kotlin",
      "React Native",
      "Java",
      "React",
      "Flutter",
      "Git",
    ],
  };
  render() {
    return (
      <div id="about">
        <p className="Name h1">Hi, I&apos;m Pradeep Kumar</p>
        <p className="Intro h4">
          Having finished my master in 2015, I started as a full-time Software
          engineer as interest and have never looked back since. I&apos;m
          currently working with the Sonata Software Limited. As a developer
          Keen to learn about new technologies. I focus on developing robust,
          modular and maintainable solutions improving myself one line of code
          at a time.
        </p>

        <p className="Skills h1">My Skills</p>
        <div className="SkillSets">
          {this.state.skills.map((item) => {
            return (
              <p key={item} className="SkillItems">
                {item}
              </p>
            );
          })}
        </div>
      </div>
    );
  }
}

export default AboutUs;
